import ProfileBar from './profile-bar';

export default ProfileBar;